import { useEffect } from "react";
import { useRawTable } from "../../hooks";
import moment from "moment";

export default function Module_ElderlyHealth_ElderlyHealthAssessmentList({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  totalRecord,
  callMainAPI,
  isResetPage,
}) {
  const { setTbData, setTbFirstIndex, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
    subTitleBgColor: "elderlytitle2",
  });

  useEffect(() => {
    if (!isResetPage) return;

    setTbFirstIndex(0);
  }, [isResetPage]);

  useEffect(() => {
    if (!apiData) return;

    const splitContent = ({ strVal, splitKey = "#" } = {}) => {
      if (!strVal) return {};

      const arr = strVal.split(splitKey);
      // 去除重複值
      const uniqueArr = [...new Set(arr)].reduce(
        (pre, cur) => ({ ...pre, [cur]: "" }),
        {}
      );
      return uniqueArr;
    };

    const formatDetail = (data) => {
      if (!data) return;

      return data.map((item) => {
        let temp = {
            ...item,
            2568: item["2568"]
              ? moment(item["2568"]).format("YYYY-MM-DD")
              : "-",
          },
          q2558 = splitContent({ strVal: item["2558"] });
        if (q2558.hasOwnProperty("12癌症")) q2558["12癌症"] = item["2559"];
        if (q2558.hasOwnProperty("13其他")) q2558["13其他"] = item["2560"];

        if (Object.keys(q2558).length !== 0) {
          temp["2558"] = Object.entries(q2558)
            .map(([key, val]) => (val ? `${key}(${val})` : key))
            .join("、");
        } else temp["2558"] = "";

        return temp;
      });
    };

    setTbData({
      raw: formatDetail(apiData),
      format: null,
      export: formatDetail(exportData),
      totalRecord,
    });
  }, [apiData, exportData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
        isPaginator: true,
        callMainAPI,
      })}
    </>
  );
}
